import clsx from 'clsx';
import * as React from 'react';

import { isTextRangeSelection, TextRange } from '@gitbook/slate';
import type { InlineProps } from '@gitbook/slate-react';

export type VoidInlineFrameProps = InlineProps & {
    onClick?: React.MouseEventHandler<HTMLSpanElement>;
    onContextMenu?: React.MouseEventHandler<HTMLSpanElement>;
    className?: string;
};

/**
 * Wrap an inline with selection controls.
 */
export const VoidInlineFrame = React.forwardRef(function VoidInlineFrameWithRef(
    props: VoidInlineFrameProps,
    ref: React.Ref<HTMLSpanElement>
): React.ReactElement {
    if (props.editor.readOnly) {
        return (
            <span
                ref={ref}
                {...props.attributes}
                className={clsx('inline-flex select-none', props.className)}
                onClick={props.onClick}
            >
                {props.children}
            </span>
        );
    }

    return (
        <span
            ref={ref}
            {...props.attributes}
            className={clsx('inline-flex select-none', props.className)}
            data-selected={props.isFocused || props.isSelected}
            onClick={(event) => {
                props.onClick?.(event);

                if (event.isDefaultPrevented()) {
                    return;
                }

                props.editor.change((change) => {
                    if (!isTextRangeSelection(change.value.selection)) {
                        change.selectText(
                            TextRange.fromBlockRange(change.value.selection, change.value.document)
                        );
                    }
                    change.collapseToStartOf(props.node).focus();
                });
            }}
            onContextMenu={(event) => {
                props.onContextMenu?.(event);
            }}
        >
            {props.children}
        </span>
    );
});
